import {
  ConciliationCaseActor,
  ConciliationCaseApproval,
  ConciliationCaseEvent,
} from "@/@types/conciliation-history";
import { ConciliationActorTypeEnum } from "@/constants/conciliation-history";

import { CASE_TIMELINE_LABELS } from "./messages";

type ActorLabel = (actor: ConciliationCaseActor | null) => string;

const userLabelOf: ActorLabel = (actor: ConciliationCaseActor | null): string =>
  actor?.name ?? CASE_TIMELINE_LABELS.UNKNOWN_ACTOR;

const ACTOR_LABELS: Readonly<Record<ConciliationActorTypeEnum, ActorLabel>> = {
  [ConciliationActorTypeEnum.SYSTEM]: (): string =>
    CASE_TIMELINE_LABELS.SYSTEM_ACTOR,
  [ConciliationActorTypeEnum.USER]: userLabelOf,
};

export const actorLabelOf = (
  event: Pick<ConciliationCaseEvent, "actor_type" | "actor">
): string => (ACTOR_LABELS[event.actor_type] ?? userLabelOf)(event.actor);

export const approvalDeciderOf = (
  approval: Pick<
    ConciliationCaseApproval,
    "decided_by" | "reconstructed" | "automatic"
  >
): string | null => {
  if (approval.decided_by) return approval.decided_by.name;

  if (approval.automatic) return CASE_TIMELINE_LABELS.SYSTEM_ACTOR;

  if (approval.reconstructed) return null;

  return CASE_TIMELINE_LABELS.UNKNOWN_ACTOR;
};
